/*
 * Copyright (c) 2021 Bolmate B.V.
 */

import {ControlVariant, ThemeProvider, voidFunction} from '@dvrd/dvr-controls';
import React, {PropsWithChildren, useState} from 'react';
import User from '../../models/userModel';
import Vehicle from '../../models/vehicleModel';
import {ChangeContextConfig, ContextShape} from '../../util/interfaces';

const defaultContext: ContextShape = {
    userContext: {
        user: null as User | null
    },
    vehicleContext: {
        vehicles: new Array<Vehicle>(),
        vehicle: null
    },
    onChangeContext: voidFunction,
    theme: {
        onChange: voidFunction,
        baseColor: '',
        borderColor: '',
        contrastColor: ''
    }
};
export const AppContext = React.createContext(defaultContext);

export default function AppContextProvider(props: PropsWithChildren<{}>) {
    const [context, setContext] = useState<ContextShape>({
        ...defaultContext, theme: {
            baseColor: '#2C7FF9',
            contrastColor: 'white',
            controlVariant: ControlVariant.SIMPLE,
            borderColor: '#D9D9D9'
        },
        onChangeContext
    });

    function onChangeContext(config: ChangeContextConfig, callback?: VoidFunction) {
        const {user, vehicle, vehicles} = config;
        const _context = {...context};
        if (user !== undefined) _context.userContext.user = user;
        if (vehicle !== undefined) _context.vehicleContext.vehicle = vehicle;
        if (vehicles !== undefined) {
            _context.vehicleContext.vehicles = vehicles;
            if (vehicles.length && !_context.vehicleContext.vehicle)
                _context.vehicleContext.vehicle = vehicles[0];
        }
        setContext(_context);
        if (callback)
            window.setTimeout(callback);
    }

    return (
        <ThemeProvider theme={context.theme}>
            <AppContext.Provider value={context}>
                {props.children}
            </AppContext.Provider>
        </ThemeProvider>
    );
}